import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Accordion from '../ui/accordion';
import Datepicker from '../ui/datepicker';
import Select from '../ui/select';
import Checkbox from '../ui/checkbox';

import {
    updateCalendarDistrict,
    updateCalendarRS,
    updateCalendarRssOss,
    updateCalendarRssOssType
} from '../../actions';

import {
    getCalendarRegionCodeList,
    getCalendarDistrictCodeList,
    getCalendarRecruitingStationCodeList,
    getCalendarRssOssCodeList
} from '../../reducers';

const makeSearchData = (
    model,
    updateCalendarDistrict,
    updateCalendarRS,
    updateCalendarRssOss,
    updateCalendarRssOssType,
    regionCodeList,
    districtCodeList,
    recruitingStationCodeList,
    rssOssCodeList
) => [
    {
        title: 'Region',
        content: (
            <Select
                model={`${model}.regionCode`}
                changeDefault={'National'}
                onChange={updateCalendarDistrict}
                options={regionCodeList}
            />
        )
    },
    {
        title: 'District',
        content: (
            <Select
                model={`${model}.districtCode`}
                onChange={updateCalendarRS}
                options={districtCodeList}
            />
        )
    },
    {
        title: 'RS',
        content: (
            <Select
                model={`${model}.recruitingStationCode`}
                onChange={updateCalendarRssOss}
                options={recruitingStationCodeList}
            />
        )
    },
    {
        title: 'RSS/OSS',
        content: (
            <Select
                model={`${model}.rssOssCode`}
                options={rssOssCodeList}
                onChange={updateCalendarRssOssType}
            />
        )
    },
    {
        title: 'Status',
        content: (
            <div className="form__status">
                <Checkbox
                    model={`${model}.eventStatus[]`}
                    options={[
                        { name: 'Event Creation', code: 'Event Creation' },
                        { name: 'Event Review', code: 'Event Review' }
                    ]}
                />
                <Checkbox
                    model={`${model}.eventReportStatus[]`}
                    options={[
                        {
                            name: 'After Action Pending',
                            code: 'After Action Pending'
                        },
                        {
                            name: 'After Action Incomplete',
                            code: 'After Action Incomplete'
                        },
                        {
                            name: 'After Action Review',
                            code: 'After Action Review'
                        },
                        {
                            name: 'Event/After Action Closed',
                            code: 'Event/After Action Closed'
                        }
                    ]}
                />
            </div>
        )
    },
    {
        title: 'Other',
        content: (
            <div>
                <Checkbox
                    model={`${model}.isFromEac[]`}
                    options={[
                        { name: 'Handheld Event', code: 'isFromEac', value: 1 }
                    ]}
                />
                <Checkbox
                    model={`${model}.isFromPr[]`}
                    options={[
                        { name: 'Influencer Event', code: 'isFromPr', value: 1 }
                    ]}
                />
            </div>
        )
    }
];

const mapStateToProps = state => ({
    regionCodeList: getCalendarRegionCodeList(state),
    districtCodeList: getCalendarDistrictCodeList(state),
    recruitingStationCodeList: getCalendarRecruitingStationCodeList(state),
    rssOssCodeList: getCalendarRssOssCodeList(state)
});

export default connect(
    mapStateToProps,
    {
        updateCalendarDistrict,
        updateCalendarRS,
        updateCalendarRssOss,
        updateCalendarRssOssType
    }
)(
    ({
        closeOnClick,
        includeDates = false,
        isActive,
        model,
        showClose = true,
        updateCalendarDistrict,
        updateCalendarRS,
        updateCalendarRssOss,
        updateCalendarRssOssType,
        regionCodeList,
        districtCodeList,
        recruitingStationCodeList,
        rssOssCodeList,
        resetCalendarBtn
    }) => (
        <section
            className={classnames('panel', `panel--${model}`, {
                'is-active': isActive
            })}
        >
            <div className="panel__inner">
                <div className="panel__actions">
                    <h1 className="panel__heading">Filters</h1>
                    {showClose ? (
                        <button
                            onClick={closeOnClick}
                            className="panel__close-btn"
                            type="button"
                        >
                            <svg className="icon icon-close">
                                <use xlinkHref="#icon-close" />
                            </svg>
                        </button>
                    ) : null}
                </div>

                {includeDates ? (
                    <div>
                        <Datepicker
                            model={`${model}.startDate`}
                            id="search-date-to"
                            title="To"
                        />

                        <Datepicker
                            model={`${model}.endDate`}
                            id="search-date-from"
                            title="From"
                        />
                    </div>
                ) : null}

                <Accordion
                    data={makeSearchData(
                        model,
                        updateCalendarDistrict,
                        updateCalendarRS,
                        updateCalendarRssOss,
                        updateCalendarRssOssType,
                        regionCodeList,
                        districtCodeList,
                        recruitingStationCodeList,
                        rssOssCodeList
                    )}
                />

                <div className="form__row">
                    <button className="form__submit" type="submit">
                        Apply
                    </button>
                    <button
                        type="button"
                        className="btn btn--reset"
                        onClick={resetCalendarBtn}
                    >
                        Reset
                    </button>
                </div>
            </div>
        </section>
    )
);



// WEBPACK FOOTER //
// ./src/components/calendar/filters.js